import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openToast } from "app/store/trackingApp/toastSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

export const getOcorrens = createAsyncThunk(
  "ocorrenciasApp/ocorrencias/getOcorrens",
  async (data: object, { dispatch }) => {
    let response;
    let responseVariaveis;
    dispatch(openLoading());
    try {
      response = await API.get("/ocorrencias", {
        params: data,
      });
      responseVariaveis = await API.get("/variavel-tabelas", {
        params: { idVariavel: 10, pagina: 1, itensPorPagina: 5000 },
      });
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível buscar as ocorrências!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    dispatch(closeLoading());
    return {
      responseData: response.data,
      responseVariaveis: responseVariaveis.data,
    };
  }
);

export const saveOcorren = createAsyncThunk(
  "ocorrenciasApp/ocorrencias/saveOcorren",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.post("/ocorrencias", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Ocorrência cadastrada",
        })
      );
      dispatch(
        getOcorrens(
          requestGetParams.ocorrenciasApp.ocorrencias.requestGetParams
        )
      );
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível cadastrar a ocorrência!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);

export const editOcorren = createAsyncThunk(
  "ocorrenciasApp/ocorrencias/editOcorren",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.put("/ocorrencias", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Ocorrência editada",
        })
      );
      dispatch(
        getOcorrens(
          requestGetParams.ocorrenciasApp.ocorrencias.requestGetParams
        )
      );
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível editar a ocorrência!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);

export const deleteOcorren = createAsyncThunk(
  "ocorrenciasApp/ocorrencias/deleteOcorren",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    const { idTipoDocumento, idCodigoLegado, idCodigoIrregularidade } = data;
    try {
      await API.delete(
        `/ocorrencias/${idTipoDocumento}/${idCodigoLegado}/${idCodigoIrregularidade}`
      );
      dispatch(
        openToast({
          severity: "success",
          title: "Ocorrência removida",
        })
      );
      dispatch(
        getOcorrens(
          requestGetParams.ocorrenciasApp.ocorrencias.requestGetParams
        )
      );
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível remover a ocorrência!",
          text: "Se certifique que a solicitação está correta",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);
